import React from 'react'
import { Typography } from '@mui/material'
import { Prompt, StepContent, CheckboxGroup } from '../components'
import resourceTypes from '../data/resource-types'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(({ typography, palette, spacing }) => ({
  title: {
    color: palette.common.black,
    ...typography.body.xs,
    lineHeight: 18 / 13,
    marginBottom: spacing(3)
  }

}))

const Step3Content = ({ data, onChange }) => {
  const classes = useStyles()

  const testAttr = suffix => `lpq-step3-${suffix}`

  return (
    <StepContent>
      <Typography className={classes.title} data-test={testAttr('title')}>
        Tell us a bit about yourself so we can tailor your learning
        recommendations
      </Typography>
      <Prompt
        prompt='Which resource types are you most interested in hearing about?'
        data-test={testAttr('resource-type-prompt')}
      />
      <CheckboxGroup
        options={resourceTypes}
        value={data.favoriteResourceTypes || []}
        onChange={value => onChange({ data: 'favoriteResourceTypes', value })}
        autoFocus
        aria-label='resource-type'
        data-test={testAttr('resource-type')}
      />
    </StepContent>
  )
}

export default Step3Content
